import React from 'react';
import { Icon } from '@mui/material';
import cx from 'classnames';
import './styles.scss';

/**
 * Tile of a catalog app: its Material icon on its color, both from the API (fleet.integrations details.ui).
 * An app without them shows its initial on a neutral tile.
 */
const AppIcon = ({ icon, color, name, className, glyphClassName }) => (
    <span className={cx('account-app-icon', className, { 'is-neutral': !color })} style={color ? { background: color } : undefined}>
        {
            icon
                ? <Icon className={cx('account-app-icon-glyph', glyphClassName)}>{icon}</Icon>
                : <span className={cx('account-app-icon-initial', glyphClassName)}>{(name || '').trim().charAt(0).toUpperCase()}</span>
        }
    </span>
);

export default AppIcon;
